var $ = require('jQuery');
var _version = 1;
var _appversion = '';
var _appid = '';
var _appkey = '';
var _devid = '';
var _cookiename = 'wmda';  // 用于存储缓存信息（devid以及appversion）
var _pn = '';
var _url_get_deviceid = '//reportwmda.58.com/get_deviceid';
var _url_report = '//reportwmda.58.com/appreport';
var _evs = [];
var _report_interval_time; //秒
var _report_interval_count;

var getCookie = function (name) {
    if (document.cookie.length === 0)
        return null;

    var start = document.cookie.indexOf(name + "=");
    if (start === -1)
        return null;

    start = start + name.length + 1;
    var end = document.cookie.indexOf(';', start);
    if (end === -1)
        end = document.cookie.length;
    return document.cookie.substring(start, end);
};

var setCookie = function (name, value) {
    var expiredays = 365;
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = name + '=' + value + ';expires=' + exdate.toGMTString();
};

var create_devid = function (cb) {
    $.ajax({
        url: _url_get_deviceid,
        type: 'GET',
        dataType: 'jsonp',
        data: {
            device: JSON.stringify({
                appid: _appid,
                info: {
                    appver: _appversion,
                    brand: 'browser',
                    devtmodel: '',
                    imei: '',
                    ip: '',
                    location: {},
                    mac: '',
                    osver: '',
                    pn: _pn
                },
                'version': _version
            }),
            Authorization: _appkey
        },
        success: function (res) {
            if (res.msgcode == 0) {
                cb(res.devid)
            }
        },
        error: function (xhr, status, err) {
        },
        complete: function (xhr, status) {
        }
    });
};

var get_devid = function (cb) {
    var cookiename = _cookiename;
    var cookievalue = getCookie(cookiename);
    if (cookievalue && cookievalue.length > 0) {
        return cb(cookievalue);
    }

    create_devid(function (devid) {
        setCookie(cookiename, devid);
        cb(devid);
    });
};

var report = function (_evs, success, error) {
    $.ajax({
        url: _url_report,
        type: 'GET',
        dataType: 'jsonp',
        data: {
            report: JSON.stringify({
                appid: _appid,
                devid: _devid,
                events: _evs,
                'version': _version
            }),
            Authorization: _appkey
        },
        success: function () {
            success && success();
        },
        error: function () {
            error && error();
        },
        complete: function (xhr, status) {
        }
    });
};

var multiReport = function () {
    var IntervalReport = (function () {
        var count = 0;
        return function () {
            setTimeout(function () {
                //数据超过10条
                if (_evs && _evs.length >= _report_interval_count) {
                    report(_evs, function () {
                        _evs.splice(0, _evs.length);
                        IntervalReport();
                    }, function () {
                        IntervalReport();
                    });
                } else {
                    count++;
                    //超过十秒，直接上报
                    if (count >= _report_interval_time && _evs && _evs.length > 0) {
                        report(_evs, function () {
                            _evs.splice(0, _evs.length);
                            IntervalReport();
                            count = 0;
                        }, function () {
                            IntervalReport();
                        });
                    } else {
                        IntervalReport();
                    }
                }
            }, 1000);
        }
    })();
    IntervalReport();
};

var stat = {};
stat.init = function (options) {
    _appversion = options.appversion;
    _appid = options.appid;
    _appkey = options.appkey;
    _cookiename = options.cookiename;
    _pn = options.pn;
    _report_interval_time = options.reportIntervalTime;
    _report_interval_count = options.reportIntervalCount;


    //获取devid
    get_devid(function (devid) {
        _devid = devid;
    });
    //启动定时上传日志
    multiReport();
    //页面关闭或者刷新事件发生,直接上报数据
    window.onbeforeunload = function () {
        if (_devid && _devid.length > 0 && _evs.length > 0) {
            report(_evs, function () {
                _evs.splice(0, _evs.length);
            }, function () {
                _evs.splice(0, _evs.length);
            });
        }
    };
};
stat.report = function (point) {
    if (!_devid || _devid.length == 0) {
        get_devid(function (devid) {
            _devid = devid;
            _evs.push({
                id: point,
                time: parseInt((new Date().getTime()) / 1000) + ''
            });
        })
    } else {
        _evs.push({
            id: point,
            time: parseInt((new Date().getTime()) / 1000) + ''
        });
    }
};

module.exports = stat;